import { useMemo } from 'react';

import { BidSheetRow } from '../../../hooks/useBidSheetState';

const useTotals = (rows: BidSheetRow[]) =>
  useMemo(
    () => [rows.reduce((acc, row) => acc + row.downPayment, 0), rows.reduce((acc, row) => acc + row.total, 0)] as const,
    [rows],
  );

export default useTotals;
